import styles from './SearchBar.css'

class SearchBar extends React.Component {
  render () {
    let {input, placeholder, className} = this.props
    return (
      <div className={`${styles['right-inner-addon']} ` + className || ''} onClick={this.props.onClick}>
        <i className='fa fa-search search-items' />
        <input {...input}
          className={'form-control ' + styles.rounded}
          placeholder={placeholder}
          type='text'
        />
      </div>
    )
  }
}

SearchBar.propTypes = {
  placeholder: React.PropTypes.string
}

export default SearchBar



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SearchBar/SearchBar.js